import React from 'react'
import Header from '../../components/headers/Header'
import { MiFooter } from '../../components/footer/MiFooter'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import { ContentPreguntasFrecuentes } from '../../components/preguntasFrecuentes/ContentPreguntasFrecuentes'
import './PreguntasFrecuentes.css'
import { Helmet } from 'react-helmet'

export const PreguntasFrecuentes = () => {

    const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)
    const closeMenu = () => {
        if (MenuLateral === true) {
            setMenuLateral(false)
        }
    }

    return (
        <div>
            <Helmet>
                <link rel="canonical" href="https://www.cuidatia.org/preguntas-frecuentes" />
            </Helmet>
            <div className='headerReservarServicio'>
                <Header />
            </div>
            <div className='faq-body'>
                <ContentPreguntasFrecuentes />
            </div>
            <div className='footerReservarServicio'>
                <MiFooter />
            </div>
        </div>
    )
}